module.exports = __webpack_public_path__ + "static/contract-f83fe4cf30eccc90a4aa17c1d1f62b9f.pdf";